import { useEffect, useRef } from 'react'

/**
 * Bluetooth barcode scanners act as keyboards: a burst of characters ending with Enter. This listens on the window,
 * so scanning works from anywhere on the screen without a focused field, and ignores slow human typing in inputs.
 */
export function useScanner(onScan: (code: string) => void, enabled = true) {
  const buf = useRef(''); const last = useRef(0)
  useEffect(() => {
    if (!enabled) return
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null
      const inField = !!target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')
      const now = Date.now()
      if (now - last.current > 120) buf.current = ''   // scanner keystrokes arrive within a few ms of each other
      last.current = now
      if (e.key === 'Enter') {
        const code = buf.current; buf.current = ''
        if (code.length >= 4) { if (inField) e.preventDefault(); onScan(code) }
        return
      }
      if (e.key.length === 1 && !e.metaKey && !e.ctrlKey) {
        buf.current += e.key
        if (!inField && buf.current.length > 1) e.preventDefault()
      }
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [onScan, enabled])
}
